import React, { useEffect, useState } from 'react';
import { Clock3, LogIn, LogOut, ChevronLeft, ChevronRight } from 'lucide-react';
import { barcodeAPI } from '../api/apiService';
import './ShiftLiveLog.css';

const PAGE_SIZE = 20;

export default function MyShiftHistory() {
  const [records, setRecords]   = useState([]);
  const [total, setTotal]       = useState(0);
  const [offset, setOffset]     = useState(0);
  const [loading, setLoading]   = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate]     = useState('');

  const fetch = (off = 0) => {
    setLoading(true);
    const params = { limit: PAGE_SIZE, offset: off };
    if (fromDate) params.from_date = fromDate;
    if (toDate)   params.to_date   = toDate;

    barcodeAPI.history(params)
      .then(data => {
        setRecords(data.records || []);
        setTotal(data.total || 0);
        setOffset(off);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetch(0); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const totalPages  = Math.ceil(total / PAGE_SIZE);
  const currentPage = Math.floor(offset / PAGE_SIZE) + 1;

  return (
    <div className="sll-page">

      {/* Header */}
      <div className="ks-header" style={{ marginBottom: '1.25rem' }}>
        <div className="ks-header-icon"><Clock3 size={20} /></div>
        <div>
          <h1 className="ks-title">My Attendance Logs</h1>
          <p className="ks-subtitle">Your personal check-in and check-out records</p>
        </div>
      </div>

      {/* Filters */}
      <div className="sll-controls">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
          <label style={{ fontSize: '0.82rem', color: '#64748b', fontWeight: 500 }}>From:</label>
          <input
            type="date"
            className="ks-est-select"
            value={fromDate}
            onChange={e => setFromDate(e.target.value)}
          />
          <label style={{ fontSize: '0.82rem', color: '#64748b', fontWeight: 500 }}>To:</label>
          <input
            type="date"
            className="ks-est-select"
            value={toDate}
            onChange={e => setToDate(e.target.value)}
          />
          <button className="sll-btn-refresh" onClick={() => fetch(0)}>Search</button>
        </div>
        <p style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{total} records total</p>
      </div>

      {/* Table */}
      <div className="sll-table-card">
        {loading ? (
          <div className="sll-loading">
            <div className="mb-spinner" />
            <p>Loading history…</p>
          </div>
        ) : records.length === 0 ? (
          <div className="sll-empty">
            <Clock3 size={40} />
            <p>No shift records found for the selected period.</p>
          </div>
        ) : (
          <>
            <div className="sll-table-wrap">
              <table className="sll-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map(r => (
                    <tr key={r.id}>
                      <td style={{ color: 'var(--theme-text)', fontWeight: 500 }}>
                        {new Date(r.scan_time).toLocaleDateString('en-IN', {
                          weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
                        })}
                      </td>
                      <td>
                        <span className={`sll-type-badge ${r.scan_type === 'CHECKIN' ? 'sll-badge-in' : 'sll-badge-out'}`}>
                          {r.scan_type === 'CHECKIN'
                            ? <><LogIn size={11} /> Check-in</>
                            : <><LogOut size={11} /> Check-out</>}
                        </span>
                      </td>
                      <td className="sll-time">
                        {new Date(r.scan_time).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="sll-pagination">
                <button
                  className="sll-page-btn"
                  disabled={currentPage === 1}
                  onClick={() => fetch(offset - PAGE_SIZE)}
                >
                  <ChevronLeft size={15} />
                </button>
                <span className="sll-page-info">Page {currentPage} of {totalPages}</span>
                <button
                  className="sll-page-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => fetch(offset + PAGE_SIZE)}
                >
                  <ChevronRight size={15} />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
